import React from "react";
import { LanguageMenuStyles } from "./LanguageMenu.style";
import { Menu, MenuItem, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from "moment";

interface LanguageMenuProps {
  lang: string;
}

const languages = [
  { name: "English", key: "en" },
  { name: "Deutsch", key: "de" },
  { name: "Español", key: "es" },
];

export const LanguageMenu: React.FC<LanguageMenuProps> = (props) => {
  const classes = LanguageMenuStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [language, setLanguage] = React.useState(props.lang);
  const { i18n } = useTranslation();

  moment.locale(props.lang);

  const handleButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClick = (
    event: React.MouseEvent<HTMLElement>,
    lang: string
  ) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
    setAnchorEl(null);
    moment.locale(lang);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getLanguage = (key: string): string => {
    const lang = languages.find(
      (lang) =>
        lang.key.localeCompare(key.substring(0, 2), undefined, {
          sensitivity: "accent",
        }) === 0
    );
    if (lang === undefined) return "English";
    else return lang.name;
  };

  return (
    <div className={classes.root}>
      <Button
        variant="contained"
        size="small"
        color="secondary"
        aria-controls="language-menu"
        aria-haspopup="true"
        onClick={handleButtonClick}
      >
        {getLanguage(language)}
      </Button>
      <Menu
        id="lang-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.key}
            selected={lang.key === language}
            onClick={(event) => handleMenuClick(event, lang.key)}
          >
            {lang.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
